import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UserHelperService } from "@main/users/user-helper.service";
import { IM1Service } from "@project/services/im1.service";

@Component({
    selector: "player-nhs-full-request",
    templateUrl: "./player-nhs-full-request.component.html",
    styleUrls: ["./player-nhs-full-request.component.scss"]
})
export class PlayerNHSFullRequestComponent implements OnInit {
    private _visible = false;
    private _secondStepVisible = false;

    oneMonthRequest: boolean = false;

    constructor(private userHelperService: UserHelperService, private im1Service: IM1Service) {}

    async ngOnInit() {
        const patientLimitedNhsAccessInfo = await this.im1Service.patientHasLimitedAccess();
        if (patientLimitedNhsAccessInfo.hasLimitedAccess) {
            const lastAccessRequestString = await this.im1Service.getLastAccessRequestedDate(this.userHelperService.patientId);
            const lastAccessRequest = new Date(lastAccessRequestString);
            const actualDate = new Date();

            const months =
                lastAccessRequestString == null
                    ? -1
                    : (actualDate.getFullYear() - lastAccessRequest.getFullYear()) * 12 +
                      (actualDate.getMonth() - lastAccessRequest.getMonth());

            this.oneMonthRequest = months >= 1;

            if (this.oneMonthRequest) {
                await this.im1Service.updateLastAccessRequestedDate();
            }

            if (months != 0 && patientLimitedNhsAccessInfo.isPatientLogged) {
                this.visible = true;
            }
        }
    }

    set visible(visible: boolean) {
        this._visible = visible;
        this.visibleChanged.emit(visible);
    }

    set secondStepVisible(visible: boolean) {
        this._secondStepVisible = visible;
        this.visibleChanged.emit(visible);
    }

    get visible(): boolean {
        return this._visible;
    }

    get secondStepVisible(): boolean {
        return this._secondStepVisible;
    }

    get labelMessage(): string {
        return this.oneMonthRequest
            ? "We have requested on your behalf, and here is a letter you can send to your GP for full access."
            : "You have limited access to NHS Data";
    }

    @Output() readonly visibleChanged = new EventEmitter<boolean>();

    openSecondStep() {
        this.visible = false;
        this.secondStepVisible = true;
    }

    async confirmSecondStep() {
        await this.im1Service.updateLastAccessRequestedDate();
        this.closeSecondStep();
        await this.im1Service.requestMedicalRecordAccess();
    }

    closeSecondStep() {
        this.secondStepVisible = false;
    }
}
